import { useState } from 'react';
import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';
import { useRect } from 'react-use-rect';
import { getPlayerControls, useIsWaveformProgress } from '../../../../helpers';
import { Buttons } from '../../../buttons';
import { Description, Image, TrackInfo } from '../../../common';
import { useSource } from '../../../sources';
import { ProgressBar, SmallPlayControls, Waveform } from '../../player-parts';
import { Playlist } from '../../playlist';

export function BigImage() {
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerRef] = useRect(({ width }) => setContainerWidth(width), {
    resize: true
  });
  const { currentItem } = useSource();
  const {
    playerParts,
    playlistHeight,
    coverImage,
    controls: derivedControls,
    existingPlayerControls,
    playerControls
  } = useSettings();
  const controls = getPlayerControls(
    derivedControls,
    existingPlayerControls,
    playerControls
  );

  const { image, title, description, hasTitle, hasAuthor } = currentItem ?? {};

  const { url } = coverImage ?? {};

  const showDescription = playerParts.includes('description') && description;
  const isWaveformProgress = useIsWaveformProgress();

  return (
    <Container ref={containerRef}>
      <Component>
        {playerParts.includes('image') && (
          <ImageContainer trackName={title} link={url || image} />
        )}

        {(!hasTitle || !hasAuthor || !playerParts.includes('status')) && (
          <InfoContainer>
            <TrackInfo wrapTitle />
          </InfoContainer>
        )}

        {showDescription && <Description text={description} />}

        <Show when={controls.includes('progressBar')}>
          <Show when={isWaveformProgress} fallback={<StyledProgressBar />}>
            <Waveform />
          </Show>
        </Show>

        <SmallPlayControls forceOneLine />

        <Buttons containerWidth={containerWidth} />
      </Component>

      <StyledPlaylist maxHeight={playlistHeight} hideDirection="toTop" />
    </Container>
  );
}

const Container = styled.div``;

const Component = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
`;

const StyledProgressBar = styled(ProgressBar)`
  width: 100%;
  height: 26px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
  margin-top: 6px;
  z-index: 1;
`;

const StyledPlaylist = styled(Playlist)`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  bottom: 64px;
  margin-top: -6px;
  height: calc(100% - 64px);
  padding: 0 8px;
  z-index: 1;
`;

const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 12px 0;
  z-index: 1;
`;

const ImageContainer = styled(Image)`
  width: 100%;
  height: 0;
  padding-top: 100%;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 8px;
`;
